module.exports = __webpack_public_path__ + "img/34.d9d9ca71.png";